module.exports = __webpack_public_path__ + "img/dots-horizontal.4f2c4440.svg";